namespace Areas.Finance.GL {
    "use strict";


    let glDataId: number = 0;
    let projectId: number = 0;
    let accountId: number;
    let fundId: number; 
    let runQuery: boolean = false;
    let showDeleted: boolean = false;
    let projectNumber: string;
    let projectName: string;
    let accountNumber: string;
    let fundNumber: string;
    let ucopSubCodeLk: string;
    let glReference: string;
    let glSummary: string

    export function getProjectId() {
        return projectId;
    }

    export function getAccountId() {
        return accountId;
    }

    export function getAccountNumber() {
        return accountNumber;
    }

    export function getFundNumber() {
        return fundNumber;
    }

    export function getFundId() {
        return fundId;
    }

    export function getShowDeleted() {
        return showDeleted;
    }

    export function addResearch() {
        const glGrid = $("#GeneralLedgerGrid").dxDataGrid("instance");


        const selectedRows = glGrid.getSelectedRowsData();

        if (selectedRows.length) {

            var selectedRowIds = glGrid.getSelectedRowKeys().join(',');
            var url = "/Finance/Balances/AddToResearch/?ids=" + selectedRowIds;

            sendRequest(url, "", "PUT", () => { $('#GeneralLedgerGrid').dxDataGrid("instance").refresh(); });

        }

        return;
    }

    export function capitalizeSelected(e: any) {
        const glGrid = $("#GeneralLedgerGrid").dxDataGrid("instance");


        const selectedRows = glGrid.getSelectedRowsData();

        if (selectedRows.length) {

            var selectedRowIds = glGrid.getSelectedRowKeys().join(',');
            var url = "/Finance/Balances/Capitalize/?ids=" + selectedRowIds;

            sendRequest(url, "", "PUT", () => { $('#GeneralLedgerGrid').dxDataGrid("instance").refresh(); });

        }

        return;
    }

    export function unDeleteSelected(e: any) {
        const glGrid = $("#GeneralLedgerGrid").dxDataGrid("instance");


        const selectedRows = glGrid.getSelectedRowsData();

        if (selectedRows.length) {

            var selectedRowIds = glGrid.getSelectedRowKeys().join(',');
            var url = "/Finance/Balances/Undelete/?ids=" + selectedRowIds;

            sendRequest(url, "", "PUT", () => { $('#GeneralLedgerGrid').dxDataGrid("instance").refresh(); });

        }

        return;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            "<a href= '/Account/Profile/View/{placeholder}' target=\"_blank\">View</a>");
    }

    export function onGridSummarySelectionChanged(e: any) {

        const glSummaryGrid = $("#GeneralLedgerSummaryGrid").dxDataGrid("instance");

        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            projectId = selectedRows[0].projectId;
            accountId = selectedRows[0].accountId;
            accountNumber = selectedRows[0].accountNumber;
            fundNumber = selectedRows[0].fundNumber;
            fundId = selectedRows[0].fundingSourceId;

        }
        Areas.refreshGrid("GeneralLedgerGrid");
        Areas.refreshGrid("GeneralLedgerAccountNotesGrid");
        Areas.refreshGrid("GeneralLedgerNotesGrid");

    }


    export function onGridSelectionChanged(e: any) {

        const glNotesGrid = $("#GeneralLedgerNotesGrid").dxDataGrid("instance");

        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            glDataId = selectedRows[0].glDataId;

            glNotesGrid.option("disabled", false)
            if (selectedRows[0].isInternalEntry) {
                enableButton("editGLMemoButton");

            } else {
                disableButton("editGLMemoButton");
            }
        }
        else {
            glDataId = 0;
        }

    }

    export function onContentReadyDetail(e: any) {


        let selectedRows = e.component.getSelectedRowsData();

        //see if a row was selected
        selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length < 1) {

            let glNotesGrid: any = $("#GeneralLedgerNotesGrid").dxDataGrid("instance");
            glNotesGrid.option("disabled", true)
        }

    }

    export function onInitNewRowAccountNote(e: any) {

        e.data.accountId = accountId;

    }

    export function onInitNewRowNote(e: any) {

        e.data.glDataId = glDataId;
        e.data.projectNumber = projectNumber;
        e.data.accountNumber = accountNumber;
        e.data.ucopSubCodeLk = ucopSubCodeLk;
        e.data.glReference = glReference;
        e.data.glSummary = glSummary;
        e.data.glNoteDate = moment().format('YYYY-MM-DD');

    }


    export function addMemo() {

        if (projectId == 0) {
            return;
        }

        const glGrid = $("#GeneralLedgerGrid").dxDataGrid("instance");

        const parameters = {
            projectName: projectName,
            projectNumber: projectNumber,
            projectId: projectId,
            calledFrom: "GL"
        };


        const createGLMemoDialog = new Areas.Dialogs.GLMemo.CreateGLMemoDialog(memoDialogClosing, parameters);
    }

    export function editMemo() {

        if (projectId == 0) {
            return;
        }

        const glGrid = $("#GeneralLedgerGrid").dxDataGrid("instance");
        const selectedRows = glGrid.getSelectedRowsData();

        if (selectedRows.length) {

            const parameters = {
                data: selectedRows[0],
                calledFrom: "GL"
            };

            const editGLMemoDialog = new Areas.Dialogs.GLMemo.EditGLMemoDialog(memoDialogClosing, parameters);

        }
    }

    function memoDialogClosing() {
            Areas.refreshGrid("GeneralLedgerGrid");
        
    }

    export function selectProject() {

        const projectDialog = new Areas.Dialogs.Project.ProjectDialog(projectDialogClosing);
    }

    function projectDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#GetProjectForm").dxForm("instance");
        const formData: any = form.option("formData");

        projectId = data.projectId;
        projectName = data.projectName;
        projectNumber = data.projectNumber;
        formData.projectNumberName = data.projectNumber + " - " + data.projectName;
        formData.projectNumber = projectNumber;

        form.option("formData", formData);
        runQuery = true;

        //refresh everything
        Areas.refreshGrid("GeneralLedgerSummaryGrid")
        Areas.refreshGrid("GeneralLedgerGrid");
        Areas.refreshGrid("GeneralLedgerAccountNotesGrid");
        Areas.refreshGrid("GeneralLedgerNotesGrid");

    }

    export function findProject(e: any) {

        projectNumber = e.value;
        let projectNumberName = "";

        const form: any = $("#GetProjectForm").dxForm("instance");
        const formData: any = form.option("formData");

        
        var url = "/Finance/Balances/FindProject/?projectNumber=" + projectNumber;

        $.get(url,
            (data) => {
                projectId = data.projectId;

                formData.projectId = data.projectId;
                formData.projectNumberName = data.projectNumber + " - " + data.projectName;
                form.option("formData", formData);

                runQuery = true;

                //refresh everything
                Areas.refreshGrid("GeneralLedgerSummaryGrid");
                Areas.refreshGrid("GeneralLedgerGrid");
                Areas.refreshGrid("GeneralLedgerAccountNotesGrid");
                Areas.refreshGrid("GeneralLedgerNotesGrid");
            });

    }

    export function showDeletedChanged(e: any) {
        showDeleted = e.value;
        if (showDeleted) {
            showButton("unDeleteButton");
            disableButton("addGLMemoButton");
            disableButton("editGLMemoButton");
            hideButton("researchButton");
            hideButton("capitalizeButton")
        } else {
            hideButton("unDeleteButton");
            enableButton("addGLMemoButton");
            enableButton("editGLMemoButton");
            showButton("researchButton");
            showButton("capitalizeButton")
        }
        runQuery = true;

        //refresh everything
        Areas.refreshGrid("GeneralLedgerSummaryGrid")
        Areas.refreshGrid("GeneralLedgerGrid");
        Areas.refreshGrid("GeneralLedgerAccountNotesGrid");
        Areas.refreshGrid("GeneralLedgerNotesGrid");
    }



}


